import React, { Component } from 'react';
import _ from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import track from "../lib/tracking";



class DataList extends Component {

  state={
    hovered:-1,
  }

  render() {
    if(this.props.mode === "list"){
      return (
        <div className="container__results--list">
          {_.map(this.props.data, (movie,ind) => {
            return (
              <Link key={movie.original_title} className="container__movie--list" to={`/movie/${encodeURIComponent(movie.movie_id)}`}>
                <p>{movie.original_title}</p>
                <p>{movie.next_release.format("DD MMMM YYYY")}</p>
                {this.props.authed && movie.needs_review && <div className="new-tag">NEW</div>}
              </Link>
          );
          })}
        </div>
      );

    }else {
      return (
        <div className="container__results">
          {_.map(this.props.data, (movie,ind) => {
            return (
              <Link
                key={movie.movie_id}
                className={ ind === this.state.hovered ? "container__movie container__movie--hovered" : "container__movie"}
                to={`/movie/${encodeURIComponent(movie.movie_id)}`}
                onMouseEnter={() => this.setState({hovered:ind})}
                onMouseLeave={() => this.setState({hovered:-1})}
                onClick={() => track("open_movie",{movie_name: movie.original_title})}
              >
                {this.props.authed && movie.needs_review && <div className="new-tag">NEW</div>}
                {this.props.authed && movie.is_gruvi && <div className="gruvi-tag">GRUVI</div>}
                <div className="container__movie__poster" >
                  <img src={movie.poster} />
                </div>
                <div className="container__movie__date">Next Release: {movie.next_release.format("DD MMMM YYYY")}</div>
                <div className="container__movie__title">{movie.english_title}</div>
              </Link>
          );
          })}
        </div>
      );

    }

  }

}

export default DataList;



// WEBPACK FOOTER //
// ./src/components/DataList.js